import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { className } from "utils/strings";
import { ITagListItem } from "./types";

import "./TagListButton.scss";
import { metrics } from "utils/metrics";

interface ITagListButton {
  item: ITagListItem;
  visible: boolean;
  onWidth: (id: string, width: number) => void;
  onTagClick?: (name: string) => void;
  selectedTags?: string[];
}

export const TagListButton = (props: ITagListButton): JSX.Element => {
  const {
    selectedTags,
    item: { id, link, text },
    onWidth,
    onTagClick,
    visible
  } = props;
  const buttonRef = useRef<HTMLButtonElement>(null);
  const linkRef = useRef<HTMLAnchorElement>(null);
  const tagClasses = className({
    "tagButton": true,
    "visible": visible,
    "hidden": !visible,
    "niche": id.indexOf("niche:") >= 0,
    "tag": id.indexOf("tag:") >= 0,
    "selected": !!selectedTags?.includes(text)
  });

  const handleTagClick = async () => {
    if (onTagClick) {
      onTagClick(text);
      await metrics.sendTagClicked({ tag: props.item.text });
    }
  };

  useEffect(() => {
    if (onTagClick && buttonRef.current) {
      onWidth(id, buttonRef.current.offsetWidth);
    }

    if (!onTagClick && linkRef.current) {
      onWidth(id, linkRef.current.offsetWidth);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props, buttonRef.current?.offsetWidth, linkRef.current?.offsetWidth]);

  const renderButtonTag = () => {
    return (
      <button onClick={handleTagClick} className={tagClasses} ref={buttonRef} aria-label={`${text} tag`}>
        <span className="text">{text}</span>
      </button>
    );
  };

  const renderLinkTag = () => {
    return (
      <Link to={link} className={tagClasses} ref={linkRef}>
        <div className="tagContainer">
          {props.item.thumbnail && (
            <img className="icon" loading="lazy" src={props.item.thumbnail} width="24" height="24" alt={`Poster for ${text} tag`} />
          )}
          <span className="text">{text}</span>
        </div>
      </Link>
    );
  };

  const renderTag = () => {
    if (onTagClick) {
      return renderButtonTag();
    }

    return renderLinkTag();
  };

  return (
    <>
      {renderTag()}
    </>
  );
};
